<div class="body">
  <mat-toolbar class="toolbar">
    <div class="menu d-print-none">
      <button mat-icon-button class="noOutline" (click)="toggleSidenav()">
        <mat-icon>menu</mat-icon>
      </button>
    </div>
    <div class="full-width">
      <div class="row full-width">
        <div class="col-12 col-md-3 d-print-none d-flex align-items-center">
          <span class="toolbar-title">{{ moduleTitle }}</span>
        </div>
        <div
          class="col-12 col-md-3 d-flex align-items-start flex-column justify-content-center"
        >
          <h1 [ngClass]="formStatus?.color">
            <span id="serialNumber"> {{ ke?.serialNo }}</span>
            <span *ngIf="ke?.id" class="small"> for {{ ke?.shutterName }}</span>
          </h1>
          <span *ngIf="ke" class="status" [ngClass]="formStatus?.color">
            {{ formStatus?.name }}
          </span>
        </div>
        <div class="col-12 col-md-2 type-header d-flex align-items-center">
          <mat-form-field appearance="outline" *ngIf="ke" class="no-subscript">
            <mat-label>Operator initiating form</mat-label>
            <input
              aria-label="operator"
              matInput
              type="text"
              name="operator_form"
              [(ngModel)]="ke.createdByName"
              disabled
            />
          </mat-form-field>
        </div>
        <div class="col-12 col-md-2 type-header d-flex align-items-center">
          <mat-form-field appearance="outline" *ngIf="ke" class="no-subscript">
            <mat-label>Created Date</mat-label>
            <input
              matInput
              class="dateInput"
              name="dateNow"
              placeholder="Date"
              disabled
              datetime="MM-dd-yyyy"
              [value]="formatDate(ke.createdOn)"
            />
          </mat-form-field>
        </div>
        <div
          class="col-12 col-md-2 d-flex justify-content-end align-items-center"
        >
          <button
            [disabled]="createActionLoading || !ke.versionName"
            mat-flat-button
            *ngIf="ke && !ke.id"
            color="primary"
            (click)="save(1)"
          >
            Create Checklist
          </button>
          <button
            class="ml-2"
            mat-flat-button
            color="warn"
            *ngIf="ke && !ke.id"
            (click)="discard()"
          >
            Cancel
          </button>
          <button
            *ngIf="canCancel && ke?.id"
            class="d-print-none"
            mat-flat-button
            color="warn"
            (click)="cancel()"
          >
            Cancel Checklist
          </button>
          <mat-label class="text-red" *ngIf="ke?.status == -1"
            >Reason of cancelation: <b class="red">{{ disapproveReason }}</b>
          </mat-label>
        </div>
      </div>
    </div>
  </mat-toolbar>
  <mat-sidenav-container
    class="sidenav-container mat-sidenav-collapse-transition"
    autosize
  >
    <mat-sidenav
      [ngClass]="{ 'mat-sidenav-collapsed': !isExpanded && !isShowing }"
      #sidenav
      opened="true"
      class="d-print-none"
      mode="side"
      (mouseenter)="mouseenter()"
      (mouseleave)="mouseleave()"
    >
      <!-- Section 1 -->
      <mat-nav-list>
        <mat-list-item>
          <!-- <span *ngIf="isExpanded || isShowing">Filter</span> -->
          <mat-icon
            matListItemIcon
            *ngIf="!isExpanded && !isShowing"
            class="blue"
            >search</mat-icon
          >
          <filter-box
            (changed)="filter = $event"
            *ngIf="isExpanded || isShowing"
          ></filter-box>
        </mat-list-item>

        <!-- Table -->
        <mat-list-item style="height: unset">
          <div [ngClass]="{ invisible: !isExpanded && !isShowing }">
            <ke-side-panel
              [filter]="filter"
              (newDocument)="createFromSidePanel($event)"
              (rowSelected)="refresh($event)"
              (discard)="discard()"
              id="sidePanel"
              #sidePanel
            ></ke-side-panel>
          </div>
        </mat-list-item>
      </mat-nav-list>

      <!-- Section 2 -->
      <mat-nav-list id="left-nav-buttons">
        <mat-list-item
          (click)="create()"
          class="parent"
          [class.disabled]="createActionLoading"
          *ngIf="canCreate"
        >
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >Create New</span
          >
          <mat-icon matListItemIcon class="yellow">add_box</mat-icon>
        </mat-list-item>
      </mat-nav-list>
    </mat-sidenav>

    <mat-sidenav-content>
      <div class="d-flex flex-column justify-content-between">
        <div class="sidenav-content">
          <ke-section0
            id="section0"
            class="shadow-bottom"
            #section0
            [(ke)]="ke"
            (requestRefresh)="refresh($event)"
            (unselectTable)="unselect()"
            (newDocument)="create()"
          ></ke-section0>
          <ke-main-panel
            *ngIf="ke?.wfSignatures"
            #mainPanel
            id="mainPanel"
            [ke]="ke"
            (unselectTable)="sidePanel.unselect()"
            (requestRefresh)="
              $event.wfTable = undefined; sidePanel.getValues($event)
            "
          ></ke-main-panel>
        </div>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
